import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "auth auth--test-acces auth--bg-second" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"g-container g-container--fit_main-width relative relative--align_center\"><div class=\"flying-logo\"><a class=\"logo link\" href=\"/\" target=\"_self\"><span class=\"logo__image\"><img class=\"logo__img\" width=\"82\" height=\"82\" src=\"/static/app/mob-logo.svg\" alt=\"hq vpn logo\" title=\"\"></span><span class=\"logo__text\"><img class=\"logo__img\" src=\"/static/app/logo-font.svg\" alt=\"hq vpn logo text\" title=\"\"></span></a></div></div>", 1)
const _hoisted_3 = { class: "g-container g-container--fit_main-width g-container--space_special relative relative--align_center" }
const _hoisted_4 = { class: "auth-form auth-form--test-access auth-form--space-md auth-form--width_sm auth-form--width_sub" }
const _hoisted_5 = {
  key: 1,
  class: "auth-form__inner"
}
const _hoisted_6 = { class: "auth-form__title" }
const _hoisted_7 = { class: "ds-caption ds-caption--size_4xl ds-caption--size_5xl-xl ds-caption--bold ds-caption--color_dark-blue ds-caption--appearance_center" }
const _hoisted_8 = { class: "auth-form__subtitle" }
const _hoisted_9 = { class: "ds-caption ds-caption--medium ds-caption--size_2md ds-caption--color_dark-blue ds-caption--appearance_center" }
const _hoisted_10 = { class: "auth-form__wrapper" }
const _hoisted_11 = { class: "payment-page-wrapper" }
const _hoisted_12 = { class: "payment-page-btns" }
const _hoisted_13 = { class: "g-row g-row--appearance_spaced g-row--space_lg g-row--space_2xl-xl g-row--justify_center" }
const _hoisted_14 = { class: "g-cell g-cols g-cols--12 g-cols--narrow-xl" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "hq-btn__text ds-caption ds-caption--color_white ds-caption--bold ds-caption--size_2md" }
const _hoisted_17 = { class: "g-cell g-cols g-cols--12 g-cols--narrow-xl" }
const _hoisted_18 = { class: "hq-btn__text ds-caption ds-caption--color_white ds-caption--bold ds-caption--size_2md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        ($setup.load)
          ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
          : _createCommentVNode("", true),
        ("NEW" == $setup.paymentStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h1", _hoisted_7, _toDisplayString($setup.$t("Почти готово!")), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString($setup.$t("Как только платежная система обновить статус платежа, код будет отправлен вам на почту и станет доступен в личном кабинете")), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("a", {
                          class: "hq-btn hq-btn--simple-blue hq-btn--centered hq-btn--full_width hq-btn--full_height-xl hq-btn--br-radius_main hq-btn--shadowed-main",
                          href: $setup.props.cabinetLink
                        }, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString($setup.$t("В личный кабинет")), 1)
                        ], 8, _hoisted_15)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", {
                          class: "hq-btn hq-btn--green hq-btn--centered hq-btn--br-radius_main hq-btn--full_width hq-btn--full_height-xl hq-btn--shadowed-main",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.checkMethod()), ["prevent"]))
                        }, [
                          _createElementVNode("p", _hoisted_18, _toDisplayString($setup.$t('Обновить статус')), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}